import { ActivityIndicator } from "react-native"
import { useLocalSearchParams, Redirect } from "expo-router"

import { trpc } from "utils/trpc"
import { ProductForm } from "components/product-form"
import { Header } from "components/Header"
import { ar } from "i18n/ar"

export default function EditProduct() {
  const params = useLocalSearchParams<{ id: string }>()
  const id = Number.parseInt(params.id, 10)

  const product = trpc.products.get.useQuery({ id })
  const inventoryCollections = trpc.inventoryCollections.forProduct.useQuery({ productId: id })

  const header = <Header title={ar.editProduct} />

  if (product.isLoading || inventoryCollections.isLoading) {
    return (
      <>
        {header}
        <ActivityIndicator />
      </>
    )
  }

  if (product.data?.type === "WEIGHT_DEFINED_PRODUCT") {
    return <Redirect href={`/dashboard/products/${product.data.baseProductId}/edit`} />
  }

  return (
    <>
      {header}
      <ProductForm id={product.data?.id} />
    </>
  )
}
